<template>
	<div class="qwxzs-main">
		<div class="left-menu">
			<div v-for="(item, index) in menuList" :key="index" @click="toPath(index)" class="left-menu-item" :style="{backgroundImage: leftIndex === index ? 'url(../../../static/young_left_select.png)' : ''}">
				<img :src="item.image" >
			</div>
		</div>
		<div class="top-choose-box">
			<img class="zswd" src="../../../static/zyzs_select.png" v-if="topIndex == 0">
		</div>
		<img class="back_home" @click="backHome" src="../../../static/back_young_home.png" >
		<div class="left-select" v-if="topIndex === 0">
			<div v-if="zyIndex == -1">
				<div class="kpsp-main">
					<div class="kpsp-item" v-for="(item, index) in zyList" :key="index"  @click="zyIndex=index">
						<div class="kpsp-item-top">
							<img :src="$imgUrl + item.listImgPc" >
						</div>
						<div class="kpsp-item-bottom">
							<div class="kpsp-item-bottom-title">
								{{item.title}}
							</div>
							<div class="kpsp-item-bottom-time">
								<div style="margin-right: 15px;">
									时间: {{$moment(item.releaseTime).format('YYYY-MM-DD')}}
								</div>
								<div v-if="item.author">
									作者: {{item.author}}
								</div>
								<!-- <div @click.stop="like(item)">
									<i class="iconfont icondianzan" style="color: #2D5AC3;"></i>
									<span style="margin-left: 3px;">
										{{item.likeNum}}
									</span>
								</div> -->
							</div>
						</div>
					</div>
				</div>
				<page :pageObj="params" @getDataList="getData"></page>
			</div>
			<div v-else class="kpsp-details">
				<div class="back" @click="zyIndex=-1">

				</div>
				<div class="kpsp-details-img">
					<img :src="$imgUrl + zyList[zyIndex].listImgPc">
				</div>

				<Scroll class="kpsp-details-content" :height="250">
					<div v-html="zyList[zyIndex].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

					</div>
				</Scroll>
			</div>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: 'qwxzs',
		data () {
			return {
				menuList: [
					{
						path: 'qwzs',
						image: '../../../static/qwxzs.png'
					},
					{
						path: 'xxhj',
						image: '../../../static/xxhj.png'
					},
					{
						path: 'kpxjt',
						image: '../../../static/kpxjt.png'
					},
					{
						path: 'zyzs',
						image: '../../../static/zyzs.png'
					},
					{
						path: 'hdyx',
						image: '../../../static/hdyx.png'
					},
				],
				leftIndex: 3,
				topIndex: 0,
				zyList: [],
				zyIndex: -1,
				params: {
					current: 1,
					size: 3,
					channelId: 38,
					releaseTerrace: "releasePc"
				}
			}
		},
		components: {
			Page
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = true
		},
		methods: {
			backHome() {
				this.$router.push('young_index')
			},
			toPath(Index) {
				let that = this
				if(Index === 1) {
					this.$Message.info('尚未开放，敬请期待！')
					return
				}
				if(Index != that.leftIndex) {
					that.$router.push(that.menuList[Index].path)
				}
			},
			getData(data) {
				this.zyList = data
				this.zyList.forEach(item => {
					item.txt = this.format(item.txt)
				})
			},
			like(obj) {
				let that = this
				that.$http.post({
					url: '/api/like/ck/thumbsUp',
					data: {
						"targetId": obj.id,
						"likeType": 1,
						"userId": that.$http.getStorage('userId'),
						"isLike": 1
					}
				}).then(res => {
					if(res.code === 'S200') {
						obj.likeNum += 1
					} else {
						that.$Message.info(res.msg)
					}
				})
			},
			format(txt) {
				var html = txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:500px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:500px;height:auto;display:inline-block;margin:10rpx auto;"');
				return newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.qwxzs-main {
		margin-top: -33px;
		position: relative;
		width: 100%;
		min-width: 1500px;
		height: 900px;
		background-image: url(../../../static/xxhj_bg.png);
		background-size: 100% 100%;
		z-index: 1000;
		.top-choose-box {
			position: absolute;
			width: 350px;
			height: 106px;
			display: flex;
			justify-content: space-between;
			top: 50px;
			left: calc(50% + 30px);
			z-index: 998;
			.zswd {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
			.line {
				width: 52px;
				height: 2px;
				margin-top: 50px;
			}
			.zsgl {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
		}
		.bg_4 {
			position: absolute;
			width: 1150px;
			height: 350px;
			top: 227px;
			left: 250px;
			display: flex;
			justify-content: space-between;
			z-index: 997;
			.bg_4_left {
				background-image: url(../../../static/left_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
			.bg_4_middle {
				background-image: url(../../../static/qwxzs_image_4.png);
				background-size: 100% 100%;
				width: 675px;
				height: 386px;
				.bg_4_middle_image {
					width: 167px;
					height: 167px;
					border-radius: 50%;
					position: absolute;
					top: 70px;
					left: 300px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.bg_4_middle_content {
					position: absolute;
					font-size: 13px;
					color: #FFFFFF;
					top: 60px;
					left: 490px;
					width: 330px;
					text-align: left;
				}
				.ckzsd {
					position: absolute;
					top: 180px;
					right: 330px;
					// cursor: pointer;
				}
			}
			.bg_4_right {
				background-image: url(../../../static/right_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
		}

		.back_home {
			position: absolute;
			width: 102px;
			height: 102px;
			left: 66px;
			bottom: 125px;
			cursor: pointer;
		}
		.left-menu {
			position: absolute;
			width: 170px;
			height: 430px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			top: 75px;
			left: 55px;
			z-index: 1000;
			.left-menu-item {
				width: 168px;
				height: 65px;
				cursor: pointer;
				text-align: left;
				background-size: 100% 100%;
				img {
					height: 48px;
					margin-top: 9px;
				}
			}
		}
		.left-select {
			position: absolute;
			top: 150px;
			left: calc(50% - 400px);
			width: 1000px;
			height: 360px;
			.kpsp-main {
				margin-top: 50px;
				height: 360px;
				width: 100%;
				display: flex;
				.kpsp-item {
					width: 30%;
					margin: 0 1.65%;
					cursor: pointer;
					.kpsp-item-top {
						background-image: url(../../../static/zyzs_box.png);
						width: 300px;
						height: 230px;
						background-size: 100% 100%;
						position: relative;
						margin: 0 auto;
						img {
							position: absolute;
							top: 30px;
							left: 40px;
							height: 165px;
							width: 220px;
						}
					}
					.kpsp-item-bottom {
						margin: 0 auto;
						padding: 10px;
						text-align: center;
						font-size: 13px;
						color: #2D5AC3;
						line-height: 30px;
						height: 80px;
						width: 300px;
						border-radius: 8px;
						background-color: rgba(255, 255, 255, 0.6);

						.kpsp-item-bottom-title {
							font-size: 16px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							text-align: left;
						}
						.kpsp-item-bottom-time {
							display: flex;
							// justify-content: space-between;
						}
					}
				}
			}
			.kpsp-details {
				width: 100%;
				height: 500px;
				background-size: 100% 100%;
				background-image: url(../../../static/kpsp_details_bg.png);
				position: relative;
				.back {
					position: absolute;
					right: 40px;
					top: 65px;
					width: 140px;
					height: 80px;
					cursor: pointer;
				}
				.kpsp-details-img {
					position: absolute;
					left: 80px;
					top: 140px;
					width: 300px;
					height: 230px;
					background-image: url(../../../static/zyzs_box.png);
					background-size: 100% 100%;
					img {
						width: 220px;
						height: 165px;
						margin: 30px;
					}
				}
				.kpsp-details-content {
					position: absolute;
					left: 450px;
					top: 160px;
					width: 520px;
					height: 400px;

					::-webkit-scrollbar {
						width: 6px;
						background-color: #3582fb;
						border-radius: 10px;
					}

					/* 滚动槽 */
					::-webkit-scrollbar-track {
						border-radius: 10px;
					}

					::-webkit-scrollbar-thumb {
						background-color: #2a68c9;
						border-radius: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/young/zyzs.vue